/**
 * Quiz scenario7-2: una sola afirmación V/F con enunciado, correct (true/false) y cita (confirmExplanation).
 * Se edita en backoffice: texto del enunciado, si es verdadero o falso, y la cita.
 */
export const DEFAULT_SCENARIO72_OPTIONS = [
	{
		id: 1,
		text: "Según las últimas recomendaciones de la EULAR (2024)<sup>1</sup>, tras la respuesta renal, el tratamiento de la nefritis lúpica debe continuar al menos durante 3 años.",
		correct: true,
		explanation: "9. <span class=\"bold\">Después de la respuesta renal, el tratamiento de la NL debe continuar durante al menos 3 años;</span> Los pacientes tratados inicialmente con micofenolato solo o en combinación con belimumab o un inhibidor de la calcineurina deben seguir tomando estos fármacos (1a/A), mientras que el micofenolato o la azatioprina deben sustituir a la ciclofosfamida para aquellos pacientes tratados inicialmente solo con ciclofosfamida (1a/A) o en combinación con belimumab (1a/A).",
		confirmExplanation: "<sup>1</sup>Fanouriakis A, Kostopoulou M, Andersen J, et al. EULAR recommendations for management of systemic lupus erythematosus: 2023 update. Ann Rheum Dis. 2024;83:15-29. Disponible en: https://ard.bmj.com/content/83/1/15 [última consulta: 18 mar 2024].<br/><strong>EULAR:</strong> European Alliance of Associations for Rheumatology",
	},
];

/**
 * Quiz scenario7-3: una sola afirmación V/F (KDIGO), mismo esquema que 7-2 (enunciado, correct, explanation, confirmExplanation).
 */
export const DEFAULT_SCENARIO73_OPTIONS = [
	{
		id: 1,
		text: "Según la <span class=\"bold\">última guía de práctica clínica KDIGO (2024)<sup>1</sup></span>, los inhibidores de la calcineurina pueden utilizarse como inmunosupresión de mantenimiento a largo plazo, pero se requiere vigilancia para prevenir la nefrotoxicidad.",
		correct: true,
		explanation: "La guía también recoge que los resultados del estudio de continuación de 2 años (Aurora 2) sugirieron que el <span class=\"bold\">tratamiento con voclosporina durante 3 años fue seguro en pacientes con nefritis lúpica cuyo TFGe inicial era >45 ml/min/1,73 m<sup>2</sup></span>.",
		confirmExplanation: "<sup>1</sup>VV. AA. KDIGO 2024 Clinical Practice Guideline for the Management of Lupus Nephritis. Kidney International (2024) 105 (Suppl 1S), S1–S69. Disponible en: https://kdigo.org/wp-content/uploads/2024/01/KDIGO-2024-Lupus-Nephritis-Guideline.pdf [última consulta: 18 mar 2024].<br/><strong>TFGe:</strong> tasa de filtración glomerular estimada",
	},
];

/**
 * Plantilla por defecto para el quiz de Tiempo de tratamiento (escenario 7).
 * 9 opciones: 3 apartados (MPAA, Ciclofosfamida, ICN), cada uno con 3 opciones y una correcta.
 * filterLabels = títulos de los 3 apartados.
 */
export const DEFAULT_SCENARIO7_OPTIONS = [
	{ id: 1, text: "Continuar como tratamiento de mantenimiento (1-3 años)", correct: false },
	{ id: 2, text: "Continuar como tratamiento de mantenimiento (2-4 años)", correct: false },
	{ id: 3, text: "Continuar como tratamiento de mantenimiento (3-5 años)", correct: true },
	{ id: 4, text: "3 meses de tratamiento de inicio con MPAA de mantenimiento", correct: true },
	{ id: 5, text: "6 meses de tratamiento de inicio con MPAA de mantenimiento", correct: false },
	{ id: 6, text: "1 año de tratamiento de inicio con MPAA de mantenimiento", correct: false },
	{ id: 7, text: "6-12 meses, luego 6-9 meses de retirada gradual", correct: false },
	{ id: 8, text: "12-18 meses, luego 6-12 meses de retirada gradual", correct: true },
	{ id: 9, text: "18-24 meses, luego 12-18 meses de retirada gradual", correct: false },
];

export const DEFAULT_SCENARIO7_FILTER_LABELS = [
	"Análogos del ácido micofenólico (MPAA)",
	"Ciclofosfamida",
	"Inhibidores de la calcineurina (ICN)",
];
